import React, { Fragment } from 'react';
import ContentParser from 'src/ui/library/ContentParser';
import classNames from 'classnames';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import Checkbox from 'src/ui/library/Checkbox';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

export default function DocumentInfoPres({
  //modals
  showCancelEditlModal,
  showDeleteModal,
  onConfirmDeleteModal,
  onCancelModal,
  onConfirmModal,
  //state
  docState,
  isEditable,
  isSaveDisabled,
  isSaving,
  documentId,
  //actions
  onFormChange,
  onCancel,
  onEdit,
  onSave,
  onDelete,
  getDocument,
  onDocumentAccessChanged,
  // roles
  isEYPro,
  isApplicant,
  // document permissions
  accessCorporateClient,
  accessEmployee,
}) {
  const numberOfColumns = 3;
  const formClass = classNames({
    'documents-form-detail': true,
    editmode: isEditable,
  });

  if (docState.documentDetail.pageElements === undefined) {
    return null;
  }

  const data = docState.documentDetail;

  return (
    <Fragment>
      {showCancelEditlModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('cases.details.buttons.cancelEdit')}
          confirmText={intl.get('cases.details.buttons.continueEdit')}
          onCancel={onCancelModal}
          onConfirm={onConfirmModal}>
          {intl.get('cases.details.messages.confirmMessage')}
        </ConfirmDialog>
      )}

      {showDeleteModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('documents.documentDetails.modals.cancelDelete')}
          confirmText={intl.get('documents.documentDetails.modals.confirmDelete')}
          onCancel={onCancelModal}
          onConfirm={onConfirmDeleteModal}>
          {intl.get('documents.documentDetails.modals.confirmMessage')}
        </ConfirmDialog>
      )}
      <div className="detail-body-inner">
        <section className={formClass}>
          <Grid item xs={12}>
            <Grid container className="documents-info-grid">
              <Grid item xs={12}>
                <div className="form-parser">
                  <div className="doc-info-title">{intl.get('documents.documentDetails.sections.info')}</div>
                  <hr />
                  <ContentParser
                    key={`${isEditable}-${documentId}`}
                    readOnly={!isEditable}
                    data={data}
                    numberOfColumns={numberOfColumns}
                    showLabels={false}
                    debug={false}
                    onChange={onFormChange}
                  />
                </div>
                <div className="doc-access">
                  <div className="doc-info-title">{intl.get('documents.documentDetails.sections.access')}</div>
                  <hr />

                  <div className="wrapper">
                    <Grid container className="">
                      <Grid item xs={2}>
                        {!isEditable && <label>EY</label>}
                        {isEditable && (
                          <div className="doc-access-option">
                            <Checkbox checked={true} />
                            <label>EY</label>
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={2}>
                        {!isEditable && !!accessCorporateClient && (
                          <label>{intl.get('documents.documentDetails.sections.corporateClient')}</label>
                        )}
                        {isEditable && (
                          <div className="doc-access-option">
                            <Checkbox
                              className="select-box"
                              checked={!!accessCorporateClient}
                              onChange={onDocumentAccessChanged.bind(null, 'accessCorporateClient')}
                            />
                            <label>{intl.get('documents.documentDetails.sections.corporateClient')}</label>
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={2}>
                        {!isEditable && !!accessEmployee && (
                          <label>{intl.get('documents.documentDetails.sections.applicantEmployee')}</label>
                        )}
                        {isEditable && (
                          <div className="doc-access-option">
                            <Checkbox checked={!!accessEmployee} onChange={onDocumentAccessChanged.bind(null, 'accessEmployee')} />
                            <label>{intl.get('documents.documentDetails.sections.applicantEmployee')}</label>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </section>
      </div>

      <section className="documents-actions">
        {isSaving && <ServiceSpinner open={isSaving} />}
        {isEditable ? (
          <div className="save-cancel-wrapper">
            <Button styleType="secondary" onClick={onCancel} className="action-button">
              {intl.get('documents.documentDetails.buttons.cancel')}
            </Button>
            <Button className="action-button" disabled={isSaveDisabled || isSaving} onClick={onSave}>
              {intl.get('documents.documentDetails.buttons.save')}
            </Button>
          </div>
        ) : (
          <Fragment>
            <Button onClick={() => getDocument(documentId)} styleType="cmsUpload" className="open-documents-button">
              <span>{intl.get('documents.documentDetails.buttons.open')}</span>
            </Button>
            {isEYPro && (
              <div className="edit-delete-wrapper">
                <a className="link" onClick={onEdit}>
                  <EditIcon className="icon" /> <span className="text">{intl.get('documents.documentDetails.buttons.edit')}</span>
                </a>
                <a className="link" onClick={onDelete}>
                  <DeleteIcon className="icon" /> <span className="text">{intl.get('documents.documentDetails.buttons.delete')}</span>
                </a>
              </div>
            )}
          </Fragment>
        )}
      </section>
    </Fragment>
  );
}
